import { useState, useEffect } from "react";

export function useIsScrollable() {
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const checkScrollable = () => {
      const bodyHeight = document.body.clientHeight;
      const windowHeight = window.innerHeight;
      setIsScrollable(bodyHeight > windowHeight);
    };

    // Check initially
    checkScrollable();

    // Check on window resize
    window.addEventListener("resize", checkScrollable);

    // Cleanup
    return () => window.removeEventListener("resize", checkScrollable);
  }, []);

  return isScrollable;
}
